import React from "react";
import ProductCard from "../components/home/ProductCard";
import Banner from "../components/home/Banner";

const Home = () => {
    return (
        <div>
            <Banner />
            <ProductCard />
        </div>
    );
}

export default Home;